// 小程序数据分析 — React Query hooks
import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'

export interface VisitSummary {
  date: string
  visit_total: number
  share_pv: number
  share_uv: number
}

export interface DailyTrend {
  date: string
  session_cnt: number
  visit_pv: number
  visit_uv: number
  visit_uv_new: number
  stay_time_uv: number
  stay_time_session: number
  visit_depth: number
}

export interface WeeklyTrend {
  date: string
  session_cnt: number
  visit_pv: number
  visit_uv: number
  visit_uv_new: number
  stay_time_uv: number
  stay_time_session: number
  visit_depth: number
}

export interface MonthlyTrend {
  date: string
  session_cnt: number
  visit_pv: number
  visit_uv: number
  visit_uv_new: number
  stay_time_uv: number
  stay_time_session: number
  visit_depth: number
}

export interface PortraitItem {
  name: string
  value: number
}

export interface PortraitGroup {
  province: PortraitItem[]
  city: PortraitItem[]
  gender: PortraitItem[]
  age: PortraitItem[]
  platform: PortraitItem[]
  device: PortraitItem[]
}

export interface PageVisit {
  page_path: string
  page_visit_pv: number
  page_visit_uv: number
  page_staytime_pv: number
  entrypage_pv: number
  exitpage_pv: number
  page_share_pv: number
  page_share_uv: number
}

export interface DistributionItem {
  key: number
  value: number
}

export interface DistributionGroup {
  stay_time: DistributionItem[]
  depth: DistributionItem[]
  source: DistributionItem[]
}

export interface MpSummary {
  ref_date: string
  new_user: number
  cancel_user: number
}

export interface MpCumulate {
  ref_date: string
  cumulate_user: number
}

export interface MpArticle {
  article_id: string
  title: string
  author?: string
  digest?: string
  content_url?: string
  create_time: number
}

export interface MiniprogramData {
  app_name: string
  app_id: string
  summary: VisitSummary
  daily_trend: DailyTrend
  weekly_trend: WeeklyTrend
  monthly_trend: MonthlyTrend
  portrait: PortraitGroup
  top_pages: PageVisit[]
  distribution: DistributionGroup
  data_date: string
  // 公众号数据
  mp_summary: MpSummary
  mp_cumulate: MpCumulate
  mp_articles: MpArticle[]
  // 环比变化 + 留存率
  changes: Record<string, number>
  retain: Record<string, number>
}

export function useMiniprogramOverview() {
  return useQuery({
    queryKey: ['wechat-api', 'overview'],
    queryFn: () => get<MiniprogramData>('/wechat-api/overview'),
    refetchInterval: 5 * 60 * 1000,
  })
}

export function useAllMiniprogramOverviews() {
  return useQuery({
    queryKey: ['wechat-api', 'all-overviews'],
    queryFn: () => get<MiniprogramData[]>('/wechat-api/configs'),
    refetchInterval: 5 * 60 * 1000,
  })
}
